<template>
  <div>
    <!--
			Loading
		-->
    <a-modal v-model="isLoading" :closable="false" :footer="null" :maskClosable="false" :width="200">
      <center>
        <img src="images/music.gif" width="100" />
      </center>
    </a-modal>

    <!--
			New modal, mobile's view
		-->
    <div v-if="isMobile()">
      <a-modal ref="modalNew" v-model="isShowNewModal" title="New event" :maskClosable="false" @ok="onSubmit"
        forceRender>
        <a-row type="flex" justify="space-between" align="top">
          <a-col :span="24">
            <bookingForm ref="bookingForm" forceRender />
          </a-col>
        </a-row>
      </a-modal>
    </div>

    <!--
			New modal, desktop's view
		-->
    <div v-else>
      <a-modal ref="modalNew" v-model="isShowNewModal" title="New event" width="50%" :maskClosable="false"
        @ok="onSubmit" forceRender>
        <div style="overflow-y: scroll; height: 400px; padding-right: 10px">
          <a-row type="flex" justify="space-between" align="top">
            <a-col :span="24">
              <bookingForm ref="bookingForm" forceRender />
            </a-col>
          </a-row>
        </div>
      </a-modal>
    </div>

    <a-modal ref="modalCopy" v-model="isShowCopyModal" title="Copy booking" :maskClosable="false"
      @ok="onSubmitCopyBooking" forceRender>
      <a-row type="flex" justify="space-between" align="top">
        <a-col :span="10">
          Date
          <a-date-picker v-model="copyBooking.date" />
        </a-col>
        <a-col :span="6">
          Start
          <a-select default-value="06:00" style="width: 100%" v-model="copyBooking.slotNumberStart"
            @change="onSelectStartChanged()">
            <a-select-option v-for="t in times" :key="t.i" :value="t.i">{{
      t.label
    }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          End
          <a-select default-value="07:00" style="width: 100%" v-model="copyBooking.slotNumberEnd"
            @change="onSelectEndChanged()">
            <a-select-option v-for="t in times" :key="t.i" :value="t.i">{{
      t.label
    }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </a-modal>

    <!-- 
			Data 
		-->
    <a-card :bordered="false" class="header-solid h-full">
      <!-- Title -->
      <template #title>
        <!-- Mobile's view -->
        <div v-if="isMobile()">
          <a-row type="flex" justify="space-between" align="top">
            <a-col :span="10">
              <h5 class="font-semibold m-0">{{ dateStr }}</h5>
            </a-col>
            <a-col :span="14">
              <div style="float: right">
                <div style="float: right">
                  <div style="float: right; margin-left: 5px">
                    <a-button type="primary" shape="circle" icon="plus" :disabled="isDisableBooking"
                      @click="onNewBooking" />
                  </div>
                </div>
              </div>
              <div style="float: right; margin-left: 5px">
                <a-button type="default" shape="circle" icon="reload" @click="requestData" />
              </div>
              <div style="float: right; margin-left: 5px">
                <a-button type="default" shape="circle" icon="search" @click="requestData" />
              </div>
            </a-col>
          </a-row>
          <a-row type="flex" justify="center">
            <a-col :span="24">
              <div style="margin-top: 10px">
                <buildingSelect ref="buildingSelect" :change="onBuildingChanged" />
              </div>
            </a-col>
          </a-row>
          <a-row type="flex" justify="center">
            <a-col :span="24">
              <div style="margin-top: 10px">
                <floorByBuildingSelect ref="floorByBuildingSelect" dropdownMatchSelectWidth="{false}"
                  :change="onFloorChanged" />
              </div>
            </a-col>
          </a-row>
          <a-row type="flex" justify="center">
            <a-col :span="24">
              <div style="margin-top: 10px">
                <roomByFloorAndBuildingSelect ref="roomByFloorAndBuildingSelect" />
              </div>
            </a-col>
          </a-row>
          <a-row type="flex" justify="center">
            <a-col :span="24">
              <div style="margin-top: 10px; margin-left: -5px; margin-right: 5px">
                <a-date-picker v-model="date" @change="onDateChanged" />
              </div>
            </a-col>
          </a-row>
        </div>

        <!-- Desktop's view -->
        <div v-else>
          <a-row type="flex" justify="space-between" align="top">
            <a-col :span="4">
              <h5 class="font-semibold m-0">Booking : {{ dateStr }}</h5>
            </a-col>
            <a-col :span="20">
              <div style="float: right; margin-left: 5px">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>New Booking</span>
                  </template>
                  <a-button type="primary" shape="circle" icon="plus" :disabled="isDisableBooking"
                    @click="onNewBooking" /></a-tooltip>
              </div>
              <div style="float: right; margin-left: 5px">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>Reload</span>
                  </template>
                  <a-button type="default" shape="circle" icon="reload" @click="requestData" /></a-tooltip>
              </div>
              <div style="float: right; margin-left: 5px">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>Search</span>
                  </template>
                  <a-button type="default" shape="circle" icon="search" @click="requestData" /></a-tooltip>
              </div>
              <div style="float: right; margin-right: 10px">
                <a-date-picker v-model="date" @change="onDateChanged" />
              </div>
              <div style="float: right; margin-left: 5px">
                <roomByFloorAndBuildingSelect ref="roomByFloorAndBuildingSelect" style="width: 200px" />
              </div>
              <div style="float: right; margin-left: 5px">
                <floorByBuildingSelect ref="floorByBuildingSelect" style="width: 120px" :change="onFloorChanged" />
              </div>
              <div style="float: right; margin-left: 5px">
                <buildingSelect ref="buildingSelect" style="width: 200px" :change="onBuildingChanged" />
              </div>
            </a-col>
          </a-row>
        </div>
      </template>

      <!-- 
				Body 
			-->
      <div style="
          width: 500;
          height: 70vh;
          overflow: auto;
          border-style: solid;
          border-width: 1px;
        ">
        <table id="roomTable" border="0" width="1000">
          <thead>
            <tr>
              <td>
                <div style="width: 80px">&nbsp;</div>
              </td>
              <td v-for="c in cols" :key="c">
                <div v-if="c.indexOf(':00') > -1" style="width: 40px">
                  <span>
                    {{ c }}
                  </span>
                </div>
                <div v-else style="width: 40px">&nbsp;</div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in data" :key="r.info._id">
              <th style="background: #ffffff">
                <div style="width: 150px">
                  {{ r.info.name }}
                </div>
              </th>
              <td v-for="b in r.booking" :key="b.id" :colspan="b.slotNumberEnd - b.slotNumberStart + 1" width="50">
                <!--
									Slot booked
								-->
                <a-popover :title="b.title" v-if="b.status === 'Booked'" placement="bottomLeft">
                  <template slot="content">
                    <div style="max-width: 400px">
                      Room:<br />
                      <div style="padding-left: 10px">{{ b.roomName }}</div>
                      Owner:<br />
                      <div style="padding-left: 10px">{{ b.userName }}</div>
                      Phone:<br />
                      <div style="padding-left: 10px">
                        {{
      b.userPhone !== undefined && b.userPhone !== ""
        ? b.userPhone
        : "-"
    }}
                      </div>
                      Detail:<br />
                      <div style="padding-left: 10px">
                        {{
        b.detail !== undefined && b.detail !== ""
          ? b.detail
          : "-"
      }}
                      </div>
                      <!-- attendee -->
                      <div v-if="b.attendees.length > 0">
                        Attendees:<br />
                        <div style="padding-left: 10px">
                          <a-tag :key="a" v-for="a in b.attendeesName">{{
      a
    }}</a-tag>
                        </div>
                      </div>
                      <!-- control -->
                      <a-divider />
                      <div style="margin-top: 10px; width: 100%" v-if="b.userId === id ||
      (role === 'Admin' &&
        (type === 'Admin' || type === 'AdminSystem'))
      ">
                        <center>
                          <a-button v-if="role === 'Admin' &&
      (type === 'Admin' || type === 'AdminSystem')
      " type="default" shape="circle" icon="copy" @click="onCopy(b)" />&nbsp;
                          <a-button type="default" shape="circle" icon="edit" @click="onEdit(b)" />&nbsp;
                          <a-button type="danger" shape="circle" icon="delete" @click="onDelete(b)" />
                        </center>
                      </div>
                    </div>
                  </template>
                  <!-- <div class="slotBooked" @dblclick="onSlotBookedDBClicked(b)"></div> -->
                  <div class="slotBooked">
                    <div v-if="b.slotNumberEnd - b.slotNumberStart + 1 >= 3">
                      <span v-if="b.title.length > 50">{{
                        b.title.substring(0, 50) + "..."
                        }}</span>
                      <span v-else>{{ b.title }}</span>
                    </div>
                  </div>
                </a-popover>

                <!--
									Slot available.
								-->
                <div v-else>
                  <template slot="content">
                    <!-- {{ b.slotLabel }} -->
                  </template>
                  <div class="slotAvialable"></div>
                  <!-- <div class="slotAvialable"></div> -->
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </a-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import bookingForm from "../../components/Inventories/BookingForm";
import buildingSelect from "../../components/Inventories/BuildingSelect";
import floorByBuildingSelect from "../../components/Inventories/FloorByBuildingSelect";
import roomByFloorAndBuildingSelect from "../../components/Inventories/RoomByFloorAndBuildingSelect";
import tools from "../../utils/tools";

export default {
  //
  //
  //
  components: {
    bookingForm,
    buildingSelect,
    floorByBuildingSelect,
    roomByFloorAndBuildingSelect
  },
  //
  //
  //
  data() {
    return {
      isLoading: false,
      isDisableBooking: false,
      visibleDatepicker: false,
      visibleAvialableSlot: false,
      data: null,
      cols: [],
      date: moment(),
      dateStr: moment().format("YYYY-MM-DD"),
      //
      id: localStorage.getItem("id"),
      role: localStorage.getItem("role"),
      type: localStorage.getItem("type"),
      //
      selectedItem: {
        roomName: "",
        userId: "",
        userEmail: "",
        title: "",
        detail: "",
        attendees: []
      },
      //
      mode: "new",
      //
      isShowNewModal: false,
      isShowDetailModal: false,
      isShowCopyModal: false,
      //
      isCheckedMyBooking: true,
      isCheckedMyMeeting: true,
      //
      times: [],
      //
      copyBooking: {
        date: moment(),
        slotNumberStart: 0,
        slotNumberEnd: 0
      }
    };
  },
  //
  //
  //
  beforeCreate() {
    if (!tools.isLogin()) this.$router.push("/login");
  },
  //
  //
  //
  mounted() {
    if (!tools.isLogin()) return;

    //
    for (let i = 0; i < 96; i++) {
      if (i < 24 || i > 83) continue;
      this.cols.push(this.cnv(i));
    }

    //
    for (let i = 24; i <= 84; i++) {
      this.times.push({
        i: i,
        label: this.cnv(i)
      });
    }

    //
    this.$refs.floorByBuildingSelect.isReadOnly = true;
    this.$refs.roomByFloorAndBuildingSelect.isReadOnly = true;

    // We will auto loading for Admin role only, for users it will take more performance.
    if (localStorage.getItem("role") === "Admin") {
      this.requestData();
    }

    // We will disable booking button if the user it AdminSystem type
    if (localStorage.getItem("type") === "AdminSystem") {
      this.isDisableBooking = true;
    } else {
      // Check user's status if the use was ban then he cannot book any rooms.
      axios
        .get(
          process.env.VUE_APP_INVENTORY_API +
          "/users/get/" +
          localStorage.getItem("id"),
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          if (response.data.data.ban != null && response.data.data.ban === "Enable") {
            this.isDisableBooking = true;
          } else {
            this.isDisableBooking = false;
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  //
  //
  //
  methods: {
    //
    //
    //
    hideDatepicker() {
      this.visibleDatepicker = false;
    },
    hideAvialableSlot() {
      this.visibleAvialableSlot = false;
    },
    //
    //
    //
    onSelectStartChanged() {
      this.copyBooking.slotLabelStart = this.cnv(
        this.copyBooking.slotNumberStart
      );
    },
    //
    //
    //
    onSelectEndChanged() {
      this.copyBooking.slotLabelEnd = this.cnv(this.copyBooking.slotNumberEnd);
    },
    //
    //
    //
    isMobile() {
      return tools.isMobile();
    },
    //
    //
    //
    cnv(number) {
      const hours = [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ];
      const mins = ["00", "15", "30", "45"];
      if (number => 0 && number <= 3) {
        return hours[Math.floor(number / 4)] + ":" + mins[number % 4];
      }
    },
    //
    //
    //
    requestData() {
      let dateRequest = this.dateStr;
      if (this.date !== null) {
        dateRequest = this.dateStr;
      }

      this.isLoading = true;

      let option = "";
      if (this.isCheckedMyBooking) {
        option = "my-booking";
      } else if (this.isCheckedMyMeeting) {
        option = "my-meeting";
      }

      if (
        (this.isCheckedMyBooking && this.isCheckedMyMeeting) ||
        (!this.isCheckedMyBooking && !this.isCheckedMyMeeting)
      ) {
        option = "all";
        this.isCheckedMyBooking = true;
        this.isCheckedMyMeeting = true;
      }

      axios
        .get(
          process.env.VUE_APP_INVENTORY_API +
          "/booking/search?date=" +
          dateRequest +
          "&building=" +
          this.$refs.buildingSelect.value +
          "&floor=" +
          this.$refs.floorByBuildingSelect.value +
          "&room=" +
          this.$refs.roomByFloorAndBuildingSelect.value +
          "&option=" +
          option +
          "&userId=" +
          localStorage.getItem("id"),
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          this.isLoading = false;
          this.data = response.data.data;
          // console.log(JSON.stringify(this.data));
        })
        .catch(error => {
          this.$notification.open({
            message: "Notification",
            description: error.response.data.message,
            icon: <a-icon type="close-circle" style="color: #FF0000" />
          });
          return;
        });
    },
    //
    //
    //
    onBuildingChanged(value, text) {
      if (this.$refs.buildingSelect.value === "All Buildings") {
        //
        this.$refs.floorByBuildingSelect.value = "All Floors";
        this.$refs.floorByBuildingSelect.isReadOnly = true;
        //
        this.$refs.roomByFloorAndBuildingSelect.value = "All Rooms";
        this.$refs.roomByFloorAndBuildingSelect.isReadOnly = true;
        return;
      }
      //
      this.$refs.floorByBuildingSelect.value = "All Floors";
      this.$refs.floorByBuildingSelect.isReadOnly = false;
      this.$refs.floorByBuildingSelect.requestData(
        this.$refs.buildingSelect.value
      );
      //
      this.$refs.roomByFloorAndBuildingSelect.value = "All Rooms";
      this.$refs.roomByFloorAndBuildingSelect.isReadOnly = true;
    },
    //
    //
    //
    onFloorChanged(value, text) {
      if (this.$refs.floorByBuildingSelect.value === "All Floors") {
        //
        this.$refs.roomByFloorAndBuildingSelect.value = "All Rooms";
        this.$refs.roomByFloorAndBuildingSelect.isReadOnly = true;
        return;
      }
      this.$refs.roomByFloorAndBuildingSelect.isReadOnly = false;
      this.$refs.roomByFloorAndBuildingSelect.requestData(
        this.$refs.buildingSelect.value,
        this.$refs.floorByBuildingSelect.value
      );
    },
    //
    //
    //
    onDateChanged(date) {
      if (date === null) {
        this.dateStr = moment().format("YYYY-MM-DD");
      } else {
        // console.log("date = ", date);
        this.dateStr = moment(date).local().format("YYYY-MM-DD");
      }
    },
    //
    //
    //
    onNextDate() {
      this.date = moment(this.date).add(1, "days");
      this.dateStr = moment(this.date).local().format("YYYY-MM-DD");
      this.requestData();
    },
    //
    //
    //
    onPreviousDate() {
      this.date = moment(this.date).add(-1, "days");
      this.dateStr = moment(this.date).local().format("YYYY-MM-DD");
      this.requestData();
    },
    //
    //
    //
    onHideBookingDetail() {
      this.isShowNewModal = false;
    },
    //
    //
    //
    onCopy(data) {
      this.copyBooking = { ...data };
      this.copyBooking.slotNumberEnd = data.slotNumberEnd + 1;
      this.isShowCopyModal = true;
    },
    //
    //
    //
    onEdit(data) {
      // console.log(JSON.stringify(data));
      this.onSlotBookedDBClicked(data);
    },
    //
    //
    //
    onSlotBookedDBClicked(data) {
      this.mode = "edit";

      // Check permission
      if (
        localStorage.getItem("id") !== data.userId &&
        localStorage.getItem("role") !== "Admin"
      ) {
        this.$notification.open({
          message: "Notification",
          description: "รายการนี้ไม่ใช่ของคุณ",
          icon: <a-icon type="close-circle" style="color: #FF0000" />
        });
        return;
      }

      // Popup with selected data
      this.isShowNewModal = true;
      this.$refs.bookingForm.setInfo(
        {
          bookingId: data.bookingId,
          //
          date: data.date,
          //
          userId: data.userId,
          userEmail: data.userEmail,
          userCard: data.userCard,
          userRole: data.userRole,
          //
          roomId: data.roomId,
          roomName: data.roomName,
          //
          slotLabelStart: data.slotLabelStart,
          slotLabelEnd: data.slotLabelEnd,
          slotNumberStart: data.slotNumberStart,
          slotNumberEnd: data.slotNumberEnd + 1,
          //
          title: data.title,
          detail: data.detail,
          // phone: data.phone,
          //
          attendees: data.attendees,
          //
          attendeesName: data.attendeesName
        },
        "edit"
      );
    },
    //
    //
    //
    onNewBooking() {
      this.mode = "new";

      // Check permission
      if (localStorage.getItem("type") === "AdminSystem") {
        this.$notification.open({
          message: "Notification",
          description: "ยูสเซอร์นี้ไม่สามารถจองห้องได้",
          icon: <a-icon type="close-circle" style="color: #FF0000" />
        });
        return;
      }

      // Popup
      this.isShowNewModal = true;
      this.$refs.bookingForm.setInfo(
        {
          bookingId: "",
          //
          date: this.date,
          //
          userId: localStorage.getItem("id"),
          userEmail: localStorage.getItem("username"),
          userCard: "",
          userRole: localStorage.getItem("role"),
          //
          roomId: "-",
          roomName: "-",
          //
          slotLabelStart: "06:00",
          slotNumberStart: 24,
          slotLabelEnd: this.cnv(24),
          slotNumberEnd: 24 + 1,
          //
          title: "",
          detail: "",
          // phone: localStorage.getItem("phone"),
          //
          attendees: [],
          //
          attendeesName: []
        },
        "new"
      );
    },
    //
    //
    //
    onSubmitCopyBooking() {
      this.isShowCopyModal = false;

      // Check booking time end must be more than time start
      if (this.copyBooking.slotNumberStart > this.copyBooking.slotNumberEnd) {
        this.$notification.open({
          message: "Notification",
          description: "เวลาที่จองผิดพลาด",
          icon: <a-icon type="close-circle" style="color: #FF0000" />
        });
        return;
      }

      // Convert date
      this.copyBooking.slotNumberEnd = this.copyBooking.slotNumberEnd - 1;
      this.copyBooking.date = moment(this.copyBooking.date)
        .local()
        .format("YYYY-MM-DD");

      // Send book data to backend
      axios
        .post(
          process.env.VUE_APP_INVENTORY_API + "/booking",
          this.copyBooking,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          if (!response.data.success) {
            this.$notification.open({
              message: "Notification",
              description: response.data.message,
              icon: <a-icon type="close-circle" style="color: #FF0000" />
            });
          } else {
            this.$notification.open({
              message: "Notification",
              description: response.data.message,
              icon: <a-icon type="check-circle" style="color: #00FF00" />
            });
            this.requestData();
          }
        })
        .catch(error => {
          this.$notification.open({
            message: "Notification",
            description: error.response.data.message,
            icon: <a-icon type="close-circle" style="color: #FF0000" />
          });
          return;
        });

      // Refresh calendar
      this.requestData();
    },
    //
    //
    //
    onSubmit() {
      this.isShowNewModal = false;

      if (this.mode === "new") {
        let data = this.$refs.bookingForm.getInfo();
        data.slotNumberEnd = data.slotNumberEnd - 1;

        // console.log("data new", data);

        // Check booking time end must be more than time start
        if (data.slotNumberStart > data.slotNumberEnd) {
          this.$notification.open({
            message: "Notification",
            description: "เวลาที่จองผิดพลาด",
            icon: <a-icon type="close-circle" style="color: #FF0000" />
          });
          return;
        }

        // Check selected room
        if (data.roomId === "-") {
          this.$notification.open({
            message: "Notification",
            description: "ไม่ได้ใส่ข้อมูลห้อง",
            icon: <a-icon type="close-circle" style="color: #FF0000" />
          });
          return;
        }

        // Check title
        if (data.title.length === 0) {
          this.$notification.open({
            message: "Notification",
            description: "ไม่ได้ใส่ข้อมูลการจอง",
            icon: <a-icon type="close-circle" style="color: #FF0000" />
          });
          return;
        }

        // console.log(JSON.stringify(data));
        // return;

        // Send book data to backend
        axios
          .post(process.env.VUE_APP_INVENTORY_API + "/booking", data, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          })
          .then(response => {
            if (!response.data.success) {
              this.$notification.open({
                message: "Notification",
                description: response.data.message,
                icon: <a-icon type="close-circle" style="color: #FF0000" />
              });
            } else {
              this.$notification.open({
                message: "Notification",
                description: response.data.message,
                icon: <a-icon type="check-circle" style="color: #00FF00" />
              });
              this.requestData();
            }
          })
          .catch(error => {
            this.$notification.open({
              message: "Notification",
              description: error.response.data.message,
              icon: <a-icon type="close-circle" style="color: #FF0000" />
            });
            return;
          });

        // Refresh calendar
        this.requestData();
      } else if (this.mode === "edit") {
        let data = this.$refs.bookingForm.getInfo();
        data.slotNumberEnd = data.slotNumberEnd - 1;

        // console.log(JSON.stringify(data));

        // Check booking time end must be more than time start
        if (data.slotNumberStart > data.slotNumberEnd) {
          this.$notification.open({
            message: "Notification",
            description: "เวลาที่จองผิดพลาด",
            icon: <a-icon type="close-circle" style="color: #FF0000" />
          });
          return;
        }

        // Check title
        if (data.title.length === 0) {
          this.$notification.open({
            message: "Notification",
            description: "ไม่ได้ใส่ข้อมูลการจอง",
            icon: <a-icon type="close-circle" style="color: #FF0000" />
          });
          return;
        }

        // console.log(JSON.stringify(data));
        // return;

        // Send book data to backend
        axios
          .put(process.env.VUE_APP_INVENTORY_API + "/booking", data, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          })
          .then(response => {
            if (!response.data.success) {
              this.$notification.open({
                message: "Notification",
                description: response.data.message,
                icon: <a-icon type="close-circle" style="color: #FF0000" />
              });
            } else {
              this.$notification.open({
                message: "Notification",
                description: response.data.message,
                icon: <a-icon type="check-circle" style="color: #00FF00" />
              });
              this.requestData();
            }
          })
          .catch(error => {
            this.$notification.open({
              message: "Notification",
              description: error.response.data.message,
              icon: <a-icon type="close-circle" style="color: #FF0000" />
            });
            return;
          });

        // Refresh calendar
        this.requestData();
      }
    },
    //
    // Delete data.
    //
    onDelete(item) {
      const self = this;
      this.$confirm({
        title: "ต้องการลบข้อมูลนี้หรือไม่?",
        onOk() {
          self.delete(item);
        },
        onCancel() { }
      });
    },
    //
    //
    //
    delete(item) {
      axios
        .delete(
          process.env.VUE_APP_INVENTORY_API + "/booking/" + item.bookingId,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          this.$notification.open({
            message: "Notification",
            description: "ลบรายการแล้ว",
            icon: <a-icon type="check-circle" style="color: #00FF00" />
          });
          this.requestData();
        })
        .catch(error => {
          this.$notification.open({
            message: "Notification",
            description: response.data.message,
            icon: <a-icon type="close-circle" style="color: #FF0000" />
          });
          return;
        });
    }
  }
};
</script>

<style lang="scss">
#roomTable thead>tr>th {
  position: sticky;
  left: 0;
  z-index: 2;
  background: #ffffff;
}

#roomTable thead>tr>td {
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 2;
}

#roomTable tbody>tr>th {
  position: sticky;
  left: 0;
  text-align: center;
  height: 25px;
}

.slotAvialable {
  height: 25px;
  border-style: solid;
  border-width: 1px;
  border-color: #e7e7e7;
  background-color: #fdfdfd;
}

.slotBooked {
  height: 25px;
  border-style: solid;
  border-width: 1px;
  border-color: #3494fe;
  background-color: #bddbfc;
  text-align: center;
}
</style>
